import React, { Fragment } from 'react';
import { Container, Row, Col } from 'reactstrap';
import Breadcrumb from '../../common/breadcrumb/breadcrumb';
import NotificationSettings from '../../common/notification-settings/NotificationSettings';

const Settings = () => {
  return (
    <Fragment>
      <Breadcrumb parent="Configuración" title="Configuración" />
      <Container fluid={true}>
        <Row>
          <Col xl="12">
            <NotificationSettings />
          </Col>
        </Row>
      </Container>
    </Fragment>
  );
};

export default Settings;
